export function getHashUrlParams() {
  const hash = window.location.hash
  const queryString = hash.split('?')[1]
  return new URLSearchParams(queryString || '')
}

export function getHashQueryParam(key, fallback = '') {
  return getHashUrlParams().get(key) || fallback
}
